<template>

    <div class="component-container">

        <div class="er-bloc-login">

            <div class="bloc-login-separator">

                <h1 class="title-login"
                >{{ $t('login_title') }}</h1>

                <span class="subtitle">{{ $t('login_email_secure') }}</span>

                <input-text class="er-input-text"
                            ref="inputEmail"
                            :big="true"
                            :data="loginEmail"
                            :placeholder="$t('login_email_placeholder')"
                            :type="'email'"
                            @change="testEmail"
                            @pressEnter="next"
                ></input-text>

                <button
                        class="btn btn-blue btn-big er-btn"
                        :class="{ 'btn-disable': isNotValidEmail }"
                        @click="next"
                >{{ $t('global_cta_next') }}
                </button>

            </div>

            <p class="er-secu">{{ $t('login_email_disclaimer') }}</p>

        </div>

        <page-loader ref="loader"></page-loader>

        <modal-error-provider :email="emailError" ref="MEP" :provider="provider"></modal-error-provider>

    </div>

</template>

<script>

    import Vuex from 'vuex'

    import Api from '@/api'

    import Storage from '@/helpers/storage'

    import InputText from "@/components/inputs/InputText"
    import ModalErrorProvider from '@/components/modal/ModalErrorProvider'
    import PageLoader from "@/components/PageLoader"
    import HeaderBand from '@/components/headers/HeaderBand'

    import Tag from '@/modules/tag'

    export default {

        name: 'login',

        components: {InputText, ModalErrorProvider, PageLoader, HeaderBand},

        computed: {

            ...Vuex.mapGetters(['loginEmail'])

        },

        props: {

            isOnlyEmail: {
                type: Boolean,
                default: false
            }

        },

        data() {
            return {
                error: false,
                regexMail: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                isNotValidEmail: true,
                emailError: '',
                provider: ''
            }
        },

        mounted() {

            this.$refs.inputEmail.focus()

        },

        methods: {

            ...Vuex.mapActions([
                'setEmail'
            ]),

            next() {

                Tag.clickAmplitude(this, 'next')

                const email = this.$refs.inputEmail.value

                this.setEmail(email)


                if (this.regexMail.test(email) && email.length > 0) {

                    this.$refs.loader.start()
                    this.provider = ''
                    Api.provider.get(email)
                        .then(data => {

                            Tag.infoAmplitude(this, 'login_email_provider', data.provider)

                            Storage.setItem('lastProvider', data.provider)

                            this.$router.push({path: `/login/${ data.provider }`})

                        })
                        .catch(error => {

                            this.$refs.loader.stop()


                            if (error.message === 'mx_unsupported') {

                                this.emailError = email

                                if(error.data) {

                                    this.provider = error.data.provider || ''

                                }

                                this.$refs.MEP.show(error)
                            }

                        })
                }
            },

            testEmail: function () {

                const email = this.$refs.inputEmail.value

                if (email.length > 0) {

                    this.isNotValidEmail = !this.regexMail.test(email)

                } else {

                    this.isNotValidEmail = true
                }
            }
        }
    }
</script>

<style scoped lang="scss">

    .component-container {
        display: flex;
        flex-grow: 1;
        @media screen and (min-width: $above-tablet-length) {
            align-items: center;
        }
    }

    .bloc-login-separator {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
    }

    .er-bloc-login {
        display: flex;
        flex-direction: column;
        padding: 0 16px;
        align-items: center;
        justify-content: space-between;
        @media screen and (min-width: $above-tablet-length) {
            max-width: 501px;
            border-radius: 8px;
            box-shadow: 0 1px 6px 1px rgba(0, 0, 0, 0.15);
            background-color: $white;
            padding: 42px 24px 25px;
            height: fit-content;
        }
    }

    .title-login {
        margin-top: 33px;
        font-size: 22px;
        font-weight: bold;
        line-height: 1.27;
        letter-spacing: -0.2px;
        color: $midnight;
        @media screen and (min-width: $above-tablet-length) {
            margin-top: 0;
            font-size: 32px;
            font-weight: bold;
            line-height: 1.25;
        }
    }

    .subtitle {
        margin-top: 14px;
        font-size: 12px;
        font-weight: 500;
        color: $grey;
        @media screen and (min-width: $above-tablet-length) {
            margin-top: 13px;
            font-size: 17px;
            font-weight: normal;
            font-style: normal;
            font-stretch: normal;
            line-height: 1.41;
            letter-spacing: normal;
            text-align: center;
            color: $grey;
        }
    }

    .er-input-text {
        margin: 28px 0 16px;
        width: 100%;
        @media screen and (min-width: $above-tablet-length) {
            margin: 41px 0 16px;
        }
    }

    .er-btn {
        @media screen and (min-width: $above-tablet-length) {
            max-width: 275px;
        }
    }

    .er-secu {
        font-size: 11px;
        line-height: 1.45;
        color: $midnight;
        margin: 18px 0;
        left: 16px;
        right: 16px;
        @media screen and (min-width: $above-tablet-length) {
            margin-top: 213px;
        }
    }

</style>
